module.exports = __webpack_public_path__ + "static/ola-0072aa5718fba30fded1d0c70db37a2c.jpg";